var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue, } from "vue-property-decorator";
import ArticleAttributes from "../../components/articleattributes/articleattributes.vue";
import ColorLegend from "../../components/colorlegend.vue";
import ExpandedGeometry from "../../components/expandedgeometry.vue";
import Gltf from "../../components/gltf.vue";
import { createPngImage, } from "../utilities/aux";
import { ProcessType, } from "../utilities/wsi4_interfaces";
let AssemblyInformationRow = class AssemblyInformationRow extends Vue {
    constructor() {
        super(...arguments);
        this.showGltfDialog = false;
    }
    toggleGltfDialog() {
        this.showGltfDialog = !this.showGltfDialog;
    }
    get pngImage() {
        if (this.assembly.png === undefined) {
            throw Error("Missing png for assembly");
        }
        return createPngImage(this.assembly.png);
    }
    get hasGltf() { return this.assembly.gltf !== undefined; }
    get gltfImage() { return this.assembly.gltf === undefined ? "" : this.assembly.gltf; }
    get gltfGeometry() {
        return {
            tag: "gltf",
            gltf: this.gltfImage,
            Renderer3d: this.Renderer3d,
        };
    }
    get hasBendPart() {
        return this.assembly.parts.some(p => p.processType === ProcessType.dieBending);
    }
};
__decorate([
    Prop({ required: true })
], AssemblyInformationRow.prototype, "assembly", void 0);
__decorate([
    Prop({ required: true })
], AssemblyInformationRow.prototype, "numberOfColumns", void 0);
__decorate([
    Prop({ required: true })
], AssemblyInformationRow.prototype, "Renderer3d", void 0);
__decorate([
    Prop({ required: true })
], AssemblyInformationRow.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], AssemblyInformationRow.prototype, "i18n", void 0);
AssemblyInformationRow = __decorate([
    Component({
        components: {
            ArticleAttributes,
            ColorLegend,
            ExpandedGeometry,
            Gltf,
        },
        name: "AssemblyInformationRow",
    })
], AssemblyInformationRow);
export default AssemblyInformationRow;
